export enum ECompetenceTrendResolution {
  Week = 'week',
  Month = 'month',
}

export enum EIcon {
  ADD_COMPETENCES = 'AddCompetences',
  ADD_CLASS = 'AddClass',
  ADD_FOLDER = 'AddFolder',
  ADD_REPORT = 'AddReport',
  ADD_STUDENT = 'AddStudent',
  ADD_USER = 'AddUser',
  ADD_SCHOOLYEAR = 'AddSchoolyear',
  ADMIN = 'Admin',
  AI = 'Ai',
  ANGLE = 'Angle',
  APPLE = 'Apple',
  APPROVE = 'Approve',
  ARCHIVE = 'Archive',
  AREA = 'Area',
  ARROW_DOWN = 'ArrowDown',
  ARROW_LEFT = 'ArrowLeft',
  ARROW_RIGHT = 'ArrowRight',
  ARROW_UP = 'ArrowUp',
  BANDAGE = 'Bandage',
  BICYCLE = 'Bicycle',
  BLACKBOARD = 'Blackboard',
  BOOK = 'Book',
  BOOK_CLOSED = 'BookClosed',
  BOOK_OPEN = 'BookOpen',
  BOY = 'Boy',
  BRUSH = 'Brush',
  BUBBLE = 'Bubble',
  BUBBLE_CHECK = 'BubbleCheck',
  BUBBLE_HELP = 'BubbleHelp',
  BUBBLE_PROBLEM = 'BubbleProblem',
  BUBBLE_QUOTE = 'BubbleQuote',
  CALENDAR = 'Calendar',
  CHART = 'Chart',
  CHECK = 'Check',
  CHECK_CIRCLE = 'CheckCircle',
  CHECK_CIRCLE_SOLID = 'CheckCircleSolid',
  CHECKMARK = 'CheckMark',
  CHEVRON_LEFT = 'ChevronLeft',
  CHEVRON_RIGHT = 'ChevronRight',
  CLASS = 'Class',
  CLOCK = 'Clock',
  CLOCK_WITH_STAR = 'ClockWithStar',
  CLOSE = 'Close',
  CLOUD_UPLOAD = 'CloudUpload',
  COMPETENCE = 'Competence',
  COMPETENCE2 = 'Competence2',
  COMPETENCE3 = 'Competence3',
  COMPETENCE4 = 'Competence4',
  COMPETENCE5 = 'Competence5',
  COMPETENCES = 'Competences',
  COLLECTIVE_ASSESSMENT = 'CollectiveAssessment',
  COPY = 'Copy',
  CREDIT_CARD = 'CreditCard',
  CROSS = 'Cross',
  DAVID_STAR = 'DavidStar',
  DELETE = 'Delete',
  DIVIDE = 'Divide',
  DOCUMENT = 'Document',
  DOCUMENT_CHECK = 'DocumentCheck',
  DOCUMENT_LINES = 'DocumentLines',
  DOCUMENT_PEN = 'DocumentPen',
  DOWNLOAD = 'Download',
  DRAG_HANDLE = 'DragHandle',
  DUPLICATE = 'Duplicate',
  EAR = 'Ear',
  EDIT = 'Edit',
  EMAIL = 'Email',
  EYE = 'Eye',
  FACE_RATING_HAPPY = 'FaceRatingHappy',
  FACE_RATING_NEUTRAL = 'FaceRatingNeutral',
  FACE_RATING_SAD = 'FaceRatingSad',
  FILTER = 'Filter',
  FOLDER = 'Folder',
  FOOTBALL = 'Football',
  FULLSCREEN_ENTER = 'FullscreenEnter',
  FULLSCREEN_EXIT = 'FullscreenExit',
  GAMING = 'Gaming',
  GIRL = 'Girl',
  GLASSES = 'Glasses',
  GRADUATION = 'Graduation',
  GROUP = 'Group',
  GROW = 'Grow',
  HAMMER = 'Hammer',
  HAND = 'Hand',
  HANDS_UP = 'HandsUp',
  HEART = 'Heart',
  HELP = 'Help',
  HIGHLIGHT = 'Highlight',
  HOME = 'Home',
  HOME_ADD = 'HomeAdd',
  HUNDRED = 'Hundred',
  INFO = 'Info',
  INSTITUTION = 'Institution',
  INSTITUTION2 = 'Institution2',
  INSTITUTION3 = 'Institution3',
  INVITE = 'Invite',
  KEY = 'Key',
  LAYERS = 'Layers',
  LEAF = 'Leaf',
  LENGTH = 'Length',
  LIGHT_BULB = 'LightBulb',
  LIGHTNING = 'Lightning',
  LINK = 'Link',
  LOADER = 'Loader',
  LOCATION = 'Location',
  LOCK = 'Lock',
  MAIL_CLOSED = 'MailClosed',
  MAIL_ENVELOPE = 'MailEnvelope',
  MAP = 'Map',
  MINUS_CIRCLE = 'MinusCircle',
  MOON = 'Moon',
  MORE = 'More',
  MOVE = 'Move',
  MUSIC = 'Music',
  NEW_FOLDER = 'NewFolder',
  NOTIFICATION = 'Notification',
  ORDER = 'Order',
  OWNER = 'Owner',
  PERCENTAGE = 'Percentage',
  PHONE = 'Phone',
  PLANT_ADD = 'PlantAdd',
  PLAY = 'Play',
  PLUS = 'Plus',
  PLUS_CIRCLE = 'PlusCircle',
  POINT_RIGHT = 'PointRight',
  POINT_UP = 'PointUp',
  PRESENTATION = 'Presentation',
  PRINT = 'Print',
  RATE = 'Rate',
  REMOVE = 'Remove',
  ROOM = 'Room',
  RUN = 'Run',
  SCISSORS = 'Scissors',
  SCRIBBLE = 'Scribble',
  SEARCH = 'Search',
  SEE = 'See',
  SETTINGS = 'Settings',
  SHIELD = 'Shield',
  SIDEBAR = 'Sidebar',
  SIZE = 'Size',
  SKILLS = 'Skills',
  SMILE = 'Smile',
  SMILE2 = 'Smile2',
  SNOWFLAKE = 'Snowflake',
  SPEAK = 'Speak',
  STAND = 'Stand',
  STAR = 'Star',
  STAR2 = 'Star2',
  STATISTICS = 'Statistics',
  STRUCTURE = 'Structure',
  STUDENT = 'Student',
  SUM = 'Sum',
  SUPPORT_MEASURE = 'SupportMeasure',
  SUN = 'Sun',
  SYNC = 'Sync',
  TEAM_INVITE = 'TeamInvite',
  TEMPERATURE = 'Temperature',
  TEN = 'Ten',
  THOUSAND = 'Thousand',
  THREE_D = 'ThreeD',
  THUMBS_UP = 'ThumbsUp',
  TIME = 'Time',
  UNLINK = 'Unlink',
  USER = 'User',
  USER_ADD_EXTERNAL = 'UserAddExternal',
  USER_NEW = 'UserNew',
  USERREMOVE = 'UserRemove',
  VIDEO = 'Video',
  WARNING = 'Warning',
  WEB = 'Web',
  WEEKLY_REPORT = 'WeeklyReport',
  X = 'X',
  GOOGLE = 'Google',
}

export enum EStudentAvatar {
  AVATAR_1 = 'avatar_1',
  AVATAR_2 = 'avatar_2',
  AVATAR_3 = 'avatar_3',
  AVATAR_4 = 'avatar_4',
  AVATAR_5 = 'avatar_5',
  AVATAR_6 = 'avatar_6',
  AVATAR_7 = 'avatar_7',
  AVATAR_8 = 'avatar_8',
  AVATAR_9 = 'avatar_9',
  AVATAR_10 = 'avatar_10',
  AVATAR_11 = 'avatar_11',
  AVATAR_12 = 'avatar_12',
}

export enum ETeacherAvatar {
  AVATAR_13 = 'avatar_13',
  AVATAR_14 = 'avatar_14',
  AVATAR_15 = 'avatar_15',
  AVATAR_16 = 'avatar_16',
  AVATAR_17 = 'avatar_17',
  AVATAR_18 = 'avatar_18',
  AVATAR_19 = 'avatar_19',
  AVATAR_20 = 'avatar_20',
  AVATAR_21 = 'avatar_21',
  AVATAR_22 = 'avatar_22',
  AVATAR_23 = 'avatar_23',
  AVATAR_24 = 'avatar_24',
}

export enum EAvatar {
  AVATAR_1 = 'avatar_1',
  AVATAR_2 = 'avatar_2',
  AVATAR_3 = 'avatar_3',
  AVATAR_4 = 'avatar_4',
  AVATAR_5 = 'avatar_5',
  AVATAR_6 = 'avatar_6',
  AVATAR_7 = 'avatar_7',
  AVATAR_8 = 'avatar_8',
  AVATAR_9 = 'avatar_9',
  AVATAR_10 = 'avatar_10',
  AVATAR_11 = 'avatar_11',
  AVATAR_12 = 'avatar_12',
  AVATAR_13 = 'avatar_13',
  AVATAR_14 = 'avatar_14',
  AVATAR_15 = 'avatar_15',
  AVATAR_16 = 'avatar_16',
  AVATAR_17 = 'avatar_17',
  AVATAR_18 = 'avatar_18',
  AVATAR_19 = 'avatar_19',
  AVATAR_20 = 'avatar_20',
  AVATAR_21 = 'avatar_21',
  AVATAR_22 = 'avatar_22',
  AVATAR_23 = 'avatar_23',
  AVATAR_24 = 'avatar_24',
}

export enum EDataTableCellType {
  ACTION = 'action',
  COMPONENT = 'component',
  ASSESSMENT_STATS = 'assessment-stats',
  SCHOOL_CLASS = 'school-class',
  SCHOOL_YEAR = 'school-year',
  STUDENT = 'student',
  SUBJECT_ACCESS_RIGHT = 'subject-access-right',
  SUBSCRIPTION_STATUS = 'subscription-status',
  USER = 'user',
  USER_OR_INVITATION = 'user-or-invitation',
  USER_ROLE_STATUS = 'user-role-status',
}

export enum EDataTableFilterType {
  GROUP_BY_CLASS = 'group-by-class',
  SCHOOL_CLASS = 'school-class',
  SCHOOL_YEAR = 'school-year',
  TEXT = 'text',
}

export enum EPosition {
  BOTTOM_LEFT = 'bottom-left',
  BOTTOM_RIGHT = 'bottom-right',
  BOTTOM_CENTER = 'bottom-center',
  CENTER = 'center',
  LEFT = 'left',
  RIGHT = 'right',
  TOP_CENTER = 'top-center',
  TOP_LEFT = 'top-left',
  TOP_RIGHT = 'top-right',
}

export enum ESchoolYearStatus {
  UPCOMING = 'upcoming',
  ACTIVE = 'active',
  PAST = 'past',
}

export enum ECreateClassMode {
  NEW_CLASS = 'new-class',
  MINIMAL = 'minimal',
  SELECT_CLASS = 'select-class',
  BUMP_UP_CLASS = 'bump-up-class',
}

export enum EPageHelpView {
  FAQ = 'faq',
  OVERVIEW = 'overview',
  VIDEOS = 'videos',
  RATING = 'rating',
}

export enum EStatisticsCalculationType {
  LAST_HISTORICAL_ENTRY = 'lastHistoricalEntry',
  ALL_HISTORICAL_ENTRIES = 'allHistoricalEntries',
}

export enum EReportView {
  COVER_SHEET = 'coverSheet',
  SUBJECT = 'subject',
  SUMMARY_SHEET = 'summarySheet',
}

export enum EReportDataStatus {
  // Has rated observations/entries → the report wizard has something to show.
  REPORTABLE = 'reportable',
  // Entries exist but none are rated yet → the user must finish them before reporting.
  UNRATED_ONLY = 'unratedOnly',
  // No entries at all → the user needs to create their first entry.
  NO_ENTRIES = 'noEntries',
  // No students accessible to the user in the class → students must be added first.
  NO_STUDENTS_IN_CLASS = 'noStudentsInClass',
  // No subjects accessible to the user in the class → subjects must be added first.
  NO_SUBJECTS_IN_CLASS = 'noSubjectsInClass',
}

export enum EDemoClassTourView {
  WELCOME = 'welcome',
  YOUR_CLASS = 'your-class',
  STUDENT_TABS = 'student-tabs',
  STUDENT_FILTERS = 'student-filters',
  ADD_DOCUMENTATION = 'add-documentation',
  GENERAL_NAVIGATION = 'general-navigation',
  CLASS_SELECTION = 'class-selection',
}
